export default __webpack_public_path__ + "static/media/TOPSTORIES_2.d0f6fca8.png";